// @copyright  2025 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    // Page titles
    'accrued-expense.page.title': 'Accrued Expenses',
    'accrued_expenses.page_title': 'Accrued Expenses',
    'accrued-expense.page.create.title': 'Create Accrued Expense',
    'accrued_expenses.page.update.title': 'Update Accrued Expense',
    'accrued-expense.page.all': 'All Accrued Expenses',

    // Buttons
    'accrued-expense.button.create': 'Create Accrued Expense',
    'accrued-expense.button.cancel': 'Cancel',
    'accrued-expense.button.save': 'Save',
    'accrued_expenses.edit': 'Edit',

    // Labels
    'accrued-expense.label.status': 'Status',
    'accrued_expenses.fields.accrual_number': 'Accrual Number',
    'accrued_expenses.fields.accrual_status': 'Status',
    'accrued_expenses.fields.accrual_date': 'Accrual Date',
    'accrued_expenses.fields.expected_payment_date': 'Expected Payment Date',
    'accrued_expenses.fields.entity': 'Entity',
    'accrued_expenses.fields.general_ledger_account': 'Expense Account',
    'accrued_expenses.fields.accrued_payable_account': 'Accrued Liability Account',
    'accrued_expenses.fields.currency': 'Currency',
    'accrued_expenses.fields.amount': 'Amount',
    'accrued_expenses.fields.balance_outstanding': 'Balance Outstanding',
    'accrued_expenses.fields.description': 'Description',
    'accrued_expenses.fields.reference_number': 'Reference Number',
    'accrued_expenses.fields.memo': 'Memo',
    'accrued_expenses.fields.auto_reverse': 'Auto Reverse',
    'accrued_expenses.fields.reversal_date': 'Reversal Date',
    'accrued_expenses.fields.is_recurring': 'Is Recurring',
    'accrued_expenses.fields.is_reversed': 'Is Reversed',
    'accrued-expense.label.accrual_date': 'Accrual Date',
    'accrued-expense.label.expected_payment_date': 'Expected Payment Date',
    'accrued-expense.label.entity_name': 'Entity',
    'accrued-expense.label.expense_account': 'Expense Account',
    'accrued-expense.label.accrued_liability_account': 'Accrued Liability Account',
    'accrued-expense.label.currency': 'Currency',
    'accrued-expense.label.amount': 'Amount',
    'accrued-expense.label.description': 'Description',
    'accrued-expense.label.reference_number': 'Reference Number',
    'accrued-expense.label.memo': 'Memo',
    'accrued-expense.label.auto_reverse': 'Auto Reverse',
    'accrued-expense.label.reversal_date': 'Reversal Date',

    // Placeholders
    'accrued-expense.placeholder.select_status': 'Select status',
    'accrued-expense.placeholder.search': 'Search accrued expenses...',
    'accrued_expenses.search_placeholder': 'Search accrued expenses...',

    // Search
    'accrued-expense.search.title': 'Search Accrued Expenses',
    'accrued-expense.search.keyword': 'Keyword',
    'accrued-expense.search.placeholder': 'Search accrued expenses...',

    // Filters
    'accrued_expenses.filters.status': 'Status',
    'accrued_expenses.filters.date_from': 'Date From',
    'accrued_expenses.filters.date_to': 'Date To',

    // Messages
    'accrued-expense.message.created_successfully': 'Accrued expense created successfully',
    'accrued_expenses.message.updated_successfully': 'Accrued expense updated successfully',
    'accrued_expenses.validation.form_errors': 'Please correct the errors below',

    // Errors
    'accrued-expense.error.message.error_loading_page': 'Sorry, there was an error loading the accrued expense page.',
    'accrued-expense.link.retry': 'Click here to retry',

    // Status
    'accrued_expenses.status.pending': 'Pending',
    'accrued_expenses.status.partial': 'Partial',
    'accrued_expenses.status.complete': 'Complete',
    'accrued_expenses.status.cancelled': 'Cancelled',
    'accrued_expenses.status.PENDING': 'Pending',
    'accrued_expenses.status.PARTIAL': 'Partial',
    'accrued_expenses.status.COMPLETE': 'Complete',
    'accrued_expenses.status.CANCELLED': 'Cancelled',
};
